import { render } from "./PickSalesOrders.vue?vue&type=template&id=35a2dfd0"
import script from "./PickSalesOrders.vue?vue&type=script&lang=js"
export * from "./PickSalesOrders.vue?vue&type=script&lang=js"

import "./PickSalesOrders.vue?vue&type=style&index=0&id=35a2dfd0&lang=css"

import exportComponent from "/home/websites/repositories/macgear-scanner/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__